export default __webpack_public_path__ + "static/media/marketing.efc84b16.pdf";